import { DropDownMenuItemProps } from 'frontcore/views/drop-down/domain/types'
import { Emitter } from 'mitt'
import { InjectionKey } from 'vue'

export type DropDownMenuScrollEvents = { scrollToItemId: DropDownMenuItemProps['id'] }

export const dropDownMenuScrollKey = Symbol() as InjectionKey<Emitter<DropDownMenuScrollEvents>>
